module.exports = __webpack_public_path__ + "static/media/woman-received-gift-card.35d5018e.png";